import React, {Component} from "react";
import ReactDOM from "react-dom";
import App from "../../index.js";
import "../../../fiat.css"
import { config } from "../../../configs/fiatpro"
import loaderSvg from "../../../images/fiat-loading.svg";


const brand =  {
    value: "fiat",
    id: [8,9,6],
    division : "3",
    name : "Fiat Professional"
};

function FiatApp(props){
    return (
        <App brand={brand} formName={"fca-fiatpro-raq"} config={config} loader={loaderSvg} models={config.models}/>
    )
}

ReactDOM.render(<FiatApp/>,document.getElementById("root"));
